import { Injectable } from '@angular/core';

/**
 * Both tokens live in localStorage so a route opened in a new tab can restore
 * the session. Keys are AMC-prefixed so they do not collide with other apps
 * on the same origin. clear() removes only these keys.
 */
@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  static readonly accessKey = 'amc_access_token';
  static readonly refreshKey = 'amc_refresh_token';

  getAccessToken(): string | null {
    return localStorage.getItem(TokenStorageService.accessKey);
  }

  setAccessToken(token: string | null): void {
    this.write(TokenStorageService.accessKey, token);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(TokenStorageService.refreshKey);
  }

  setRefreshToken(token: string | null): void {
    this.write(TokenStorageService.refreshKey, token);
  }

  clear(): void {
    localStorage.removeItem(TokenStorageService.accessKey);
    localStorage.removeItem(TokenStorageService.refreshKey);
    // Earlier builds kept the refresh token in sessionStorage under the same key.
    sessionStorage.removeItem(TokenStorageService.refreshKey);
  }

  hasSession(): boolean {
    return !!this.getAccessToken() || !!this.getRefreshToken();
  }

  isTokenKey(key: string | null): boolean {
    return key === TokenStorageService.accessKey || key === TokenStorageService.refreshKey;
  }

  private write(key: string, token: string | null): void {
    if (!token) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, token);
  }
}
